// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
/* for components whose styles are define, those components will pick below two configurable colors */
/* 
 - for components whose styles are not defined, those components will pick below two default colors* 
 - add styles for those components if you want configurable colors.
 - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.
 - this is a workaround as antd core styles do not accept css variables as less variable values.
*/
::selection {
  background-color: var(--app-primary-color);
  color: #fff;
}
.index-module__dashboard-container__tDY29 {
  width: 100%;
}
.index-module__section1__XqiUd {
  margin-bottom: 15px;
}
.index-module__section2__C8xX5 {
  margin-bottom: 15px;
}
.index-module__card-container__heTI3 {
  padding: 0px !important;
  height: 37vh;
  margin-bottom: 0px !important;
}
.index-module__card-title__Y8PgT {
  font-weight: bold;
}
.index-module__card-title-full-screen__nZeYh {
  font-weight: bold;
  font-size: 16px;
}
.index-module__parking-card-section__mpgPs {
  padding: 0px !important;
  height: 28vh;
  overflow-y: scroll;
}
.index-module__parking-card-section-full-screen__FhB4B {
  padding: 0px !important;
  height: 80vh;
  overflow-y: scroll;
}
.index-module__search-component__A7XxC {
  width: 18vw !important;
}
.index-module__card-header__uxrPC {
  text-transform: capitalize !important;
  font-weight: bolder;
  margin-bottom: 10px;
  margin-top: -5px !important;
}
.index-module__card-header-full-screen__gm4F_ {
  text-transform: capitalize !important;
  font-weight: bolder;
  margin-bottom: 15px;
  margin-top: -5px !important;
  font-size: 18px;
}
.index-module__table-cell__RXuGJ {
  font-weight: bolder;
}
.index-module__table-cell-small__RThEy {
  font-size: 12px;
  font-weight: bold;
}
.index-module__card-header-section__scihd {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 11px;
  gap: 10px;
  padding-right: 10px;
  font-weight: bold;
}
.index-module__card-header-section__scihd div {
  min-width: 70px;
}
.index-module__custom-table-header__KsmZA {
  text-align: center !important;
  padding: 7px 0px !important;
  font-size: 11px !important;
  font-weight: normal;
  line-height: 18px;
  color: #545454 !important;
}
.index-module__panel-header__ehX68 {
  font-weight: bolder;
}
.index-module__parking-card-header__jLjSC {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: -5px 0px 10px 0px !important;
}
.index-module__visitor-icon-section__OXzem {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.index-module__visitor-table-section___g6ZJ .index-module__custom-table-header__KsmZA {
  text-align: center !important;
  padding: 7px 0px !important;
  font-size: 11px !important;
  font-weight: normal;
  line-height: 18px;
  color: #545454 !important;
}
.index-module__parking-grid__a01I6 {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(50px, 1fr));
  grid-auto-rows: 27px;
  gap: 0px;
  height: 17vh;
  overflow-y: scroll;
  overflow-x: hidden;
  background-color: #dedada;
}
.index-module__parking-grid-full-screen__KyMF8 {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(50px, 1fr));
  grid-auto-rows: 27px;
  gap: 0px;
  height: 23vh;
  overflow-y: scroll;
  overflow-x: hidden;
  background-color: #dedada;
}
.index-module__parking-cell__ewjAR {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
  margin: 3px 0px 0px 3px !important;
  height: 25px;
  min-width: 50px;
  border-radius: 0px;
  cursor: pointer;
  transition: transform 0.3s ease-in-out, background-color 0.3s ease-in-out;
  will-change: transform;
}
.index-module__parking-cell__ewjAR:hover {
  transform: scale(1.1) translateZ(0);
  border: 3px solid red;
}
.index-module__parking-cell__ewjAR .index-module__ant-tag__hoOo3 {
  font-size: 10px;
  padding: 0px;
  border-radius: 0px;
}
.index-module__selected-cell__gFHMB {
  transform: scale(1.1) translateZ(0);
  border: 3px solid red;
}
.index-module__parked-status-color__lCugE {
  color: green;
}
.index-module__empty-status-color__HX7j1 {
  color: #265caa;
}
.index-module__dead-status-color__ddZbI {
  color: #bb3c5a;
}
.index-module__booked-status-color__AUMvD {
  color: #a43072;
}
.index-module__user-icon__cx0D5 {
  font-size: 40px;
  color: #1890ff;
  padding: 15px;
  border: 2px solid #1890ff;
  border-radius: 50%;
  display: inline-block;
}
.index-module__card-count__ZLsoH {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin-top: 8px;
}
.index-module__visitor-section1__uZ3WR {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  height: 27vh;
}
.index-module__visitor-section1-full-screen__RGwNk {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  height: 75vh;
}
.index-module__user-image__GaFIj {
  height: 10vh;
  width: 10vh;
  margin: 0 auto;
  display: block;
}
.index-module__parking-status-container-full-screen__NddxU {
  height: 80vh;
}
.index-module__parking-status-container__WpMx5 {
  height: 28vh;
}
.index-module__parking-status-container-col2__k4RKf {
  padding: 0% !important;
  border-left: 2px solid #ddd;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.index-module__parking-status-container-col2__k4RKf .index-module__border-status-box1__nnUfF {
  border-top: 2px solid #ddd !important;
}
.index-module__parking-status-container-col2__k4RKf .index-module__border-status-box2__VRITB {
  border-top: 2px solid #ddd !important;
  border-bottom: 2px solid #ddd !important;
}
.index-module__parking-status-container-col2__k4RKf .index-module__border-status-box3__OoMJ1 {
  border-bottom: 2px solid #ddd !important;
}
.index-module__parking-status-container-col2__k4RKf .index-module__status-count-container__NsXYn {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.2vh;
}
.index-module__parking-status-container-col2__k4RKf .index-module__status-count-container__NsXYn .index-module__count__Rhlkt {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2px;
  font-size: 12px;
  font-weight: 700;
}
.index-module__parking-status-container-col2__k4RKf .index-module__status-count-container__NsXYn .index-module__count-full-screen__HYM6W {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2px;
  font-size: 16px;
  font-weight: 700;
}
.index-module__parking-status-container-col2__k4RKf .index-module__status-count-container__NsXYn .index-module__label__jZ9LT {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
  color: #8c8c8c;
  line-height: 18px;
}
.index-module__parking-status-container-col2__k4RKf .index-module__status-count-container__NsXYn .index-module__label-full-screen__dV05d {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  color: #8c8c8c;
  line-height: 18px;
}
.index-module__parking-status-container-col2__k4RKf .index-module__status-count-container__NsXYn .index-module__status-container__iNiwz {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 7px;
}
.index-module__parking-status-container-col2__k4RKf .index-module__status-count-container__NsXYn .index-module__parked-status-bgcolor__f823S {
  height: 10px;
  width: 14px;
  background-color: green;
}
.index-module__parking-status-container-col2__k4RKf .index-module__status-count-container__NsXYn .index-module__empty-status-bgcolor__Rgx9M {
  height: 10px;
  width: 14px;
  background-color: #265caa;
}
.index-module__parking-status-container-col2__k4RKf .index-module__status-count-container__NsXYn .index-module__dead-status-bgcolor__lJbkI {
  height: 10px;
  width: 14px;
  background-color: #a9a9a9;
}
.index-module__parking-status-container-col2__k4RKf .index-module__status-count-container__NsXYn .index-module__booked-status-bgcolor__OIdVn {
  height: 10px;
  width: 14px;
  background-color: #f4cc07;
}
.index-module__parking-status-container-col2__k4RKf .index-module__status-count-container__NsXYn .index-module__total-status-bgcolor__FgxLV {
  height: 10px;
  width: 14px;
}
.index-module__dashboard-footer__pEOQj {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  font-weight: bold;
}
.index-module__red-color-text__X4eFI {
  color: red;
}
.index-module__blue-color-text__ZvmjQ {
  color: blue;
}
.index-module__parking-popover-header__aXFJJ {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.index-module__parking-popover-title__H7g0r {
  font-weight: bold;
}
.index-module__close-icon__FoXPY {
  display: flex;
  align-items: center;
  font-size: 24px;
  cursor: pointer;
}
.index-module__text-red__M1Vk1 {
  color: red;
  margin: 1rem 0px;
}
.index-module__details-container__FJWev {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.index-module__details-container__FJWev .index-module__detail-row__aN2n7 {
  display: flex;
  justify-content: space-between;
}
.index-module__details-container__FJWev .index-module__label__jZ9LT {
  width: 120px;
  text-align: left;
}
.index-module__details-container__FJWev .index-module__value__khiTw {
  font-weight: bold;
  flex: 1;
  text-align: left;
}
.index-module__space--width__TBvHq {
  width: 100%;
}
.index-module__main-container__lTyb7 {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 10vh;
  min-width: 30vh;
}
.index-module__popover-loading__yUi_a {
  position: absolute;
  left: 44%;
  top: 45%;
}
.index-module__card-wrapper__VOaVc {
  position: relative;
}
.index-module__resync-icon__Kl496 {
  font-size: 1.2rem;
  color: var(--app-primary-color);
  cursor: pointer;
  background-color: #fff;
  border-radius: 50%;
  padding: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s, box-shadow 0.2s;
  margin-right: 0.5rem;
  margin-top: -2px;
}
.index-module__resync-icon__Kl496:hover {
  transform: scale(1.1);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}
.index-module__maximize-icon__NPihT {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
  font-size: 1.2rem;
  color: var(--app-primary-color);
  cursor: pointer;
  background-color: #fff;
  border-radius: 50%;
  padding: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s, box-shadow 0.2s;
}
.index-module__maximize-icon__NPihT:hover {
  transform: scale(1.1);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}
.index-module__full-screen-layout__U37TE {
  height: 100%;
  width: 100%;
}
@keyframes index-module__blink-execution__zjWAe {
  0% {
    background-color: white;
  }
  50% {
    background-color: #ff7400;
  }
  100% {
    background-color: white;
  }
}
.index-module__blinking-record-execution__HNZXV {
  animation: index-module__blink-execution__zjWAe 1s linear infinite;
  color: #000000;
}
.index-module__parking-status-count-container__jyvEv {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 5px 15px;
  border-top: 1px solid #f0f0f0;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.index-module__parking-status-execution__jfD_8 {
  background-color: #ff7400;
  color: #ffffff;
  font-weight: bold;
}
.index-module__parking-status-waiting__QVFlr {
  background-color: #F4CC89;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/index.module.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;AAC7F,qGAAqG;AACrG;;;;;CAKC;AACD;EACE,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yEAAyE;EACzE,sBAAsB;AACxB;AACA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;EACxC,2CAA2C;EAC3C,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;EACxC,2CAA2C;AAC7C;AACA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE,kEAA6C;EAC7C,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,6BAA6B;EAC7B,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB","sourcesContent":["/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n/* for components whose styles are define, those components will pick below two configurable colors */\n/* \n - for components whose styles are not defined, those components will pick below two default colors* \n - add styles for those components if you want configurable colors.\n - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.\n - this is a workaround as antd core styles do not accept css variables as less variable values.\n*/\n::selection {\n  background-color: var(--app-primary-color);\n  color: #fff;\n}\n.dashboard-container {\n  width: 100%;\n}\n.section1 {\n  margin-bottom: 15px;\n}\n.section2 {\n  margin-bottom: 15px;\n}\n.card-container {\n  padding: 0px !important;\n  height: 37vh;\n  margin-bottom: 0px !important;\n}\n.card-title {\n  font-weight: bold;\n}\n.card-title-full-screen {\n  font-weight: bold;\n  font-size: 16px;\n}\n.parking-card-section {\n  padding: 0px !important;\n  height: 28vh;\n  overflow-y: scroll;\n}\n.parking-card-section-full-screen {\n  padding: 0px !important;\n  height: 80vh;\n  overflow-y: scroll;\n}\n.search-component {\n  width: 18vw !important;\n}\n.card-header {\n  text-transform: capitalize !important;\n  font-weight: bolder;\n  margin-bottom: 10px;\n  margin-top: -5px !important;\n}\n.card-header-full-screen {\n  text-transform: capitalize !important;\n  font-weight: bolder;\n  margin-bottom: 15px;\n  margin-top: -5px !important;\n  font-size: 18px;\n}\n.table-cell {\n  font-weight: bolder;\n}\n.table-cell-small {\n  font-size: 12px;\n  font-weight: bold;\n}\n.card-header-section {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  font-size: 11px;\n  gap: 10px;\n  padding-right: 10px;\n  font-weight: bold;\n}\n.card-header-section div {\n  min-width: 70px;\n}\n.custom-table-header {\n  text-align: center !important;\n  padding: 7px 0px !important;\n  font-size: 11px !important;\n  font-weight: normal;\n  line-height: 18px;\n  color: #545454 !important;\n}\n.panel-header {\n  font-weight: bolder;\n}\n.parking-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: -5px 0px 10px 0px !important;\n}\n.visitor-icon-section {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.visitor-table-section .custom-table-header {\n  text-align: center !important;\n  padding: 7px 0px !important;\n  font-size: 11px !important;\n  font-weight: normal;\n  line-height: 18px;\n  color: #545454 !important;\n}\n.parking-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(50px, 1fr));\n  grid-auto-rows: 27px;\n  gap: 0px;\n  height: 17vh;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  background-color: #dedada;\n}\n.parking-grid-full-screen {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(50px, 1fr));\n  grid-auto-rows: 27px;\n  gap: 0px;\n  height: 23vh;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  background-color: #dedada;\n}\n.parking-cell {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  font-weight: bold;\n  margin: 3px 0px 0px 3px !important;\n  height: 25px;\n  min-width: 50px;\n  border-radius: 0px;\n  cursor: pointer;\n  transition: transform 0.3s ease-in-out, background-color 0.3s ease-in-out;\n  will-change: transform;\n}\n.parking-cell:hover {\n  transform: scale(1.1) translateZ(0);\n  border: 3px solid red;\n}\n.parking-cell .ant-tag {\n  font-size: 10px;\n  padding: 0px;\n  border-radius: 0px;\n}\n.selected-cell {\n  transform: scale(1.1) translateZ(0);\n  border: 3px solid red;\n}\n.parked-status-color {\n  color: green;\n}\n.empty-status-color {\n  color: #265caa;\n}\n.dead-status-color {\n  color: #bb3c5a;\n}\n.booked-status-color {\n  color: #a43072;\n}\n.user-icon {\n  font-size: 40px;\n  color: #1890ff;\n  padding: 15px;\n  border: 2px solid #1890ff;\n  border-radius: 50%;\n  display: inline-block;\n}\n.card-count {\n  font-size: 20px;\n  font-weight: bold;\n  text-align: center;\n  margin-top: 8px;\n}\n.visitor-section1 {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n  height: 27vh;\n}\n.visitor-section1-full-screen {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n  height: 75vh;\n}\n.user-image {\n  height: 10vh;\n  width: 10vh;\n  margin: 0 auto;\n  display: block;\n}\n.parking-status-container-full-screen {\n  height: 80vh;\n}\n.parking-status-container {\n  height: 28vh;\n}\n.parking-status-container-col2 {\n  padding: 0% !important;\n  border-left: 2px solid #ddd;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.parking-status-container-col2 .border-status-box1 {\n  border-top: 2px solid #ddd !important;\n}\n.parking-status-container-col2 .border-status-box2 {\n  border-top: 2px solid #ddd !important;\n  border-bottom: 2px solid #ddd !important;\n}\n.parking-status-container-col2 .border-status-box3 {\n  border-bottom: 2px solid #ddd !important;\n}\n.parking-status-container-col2 .status-count-container {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.2vh;\n}\n.parking-status-container-col2 .status-count-container .count {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 2px;\n  font-size: 12px;\n  font-weight: 700;\n}\n.parking-status-container-col2 .status-count-container .count-full-screen {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 2px;\n  font-size: 16px;\n  font-weight: 700;\n}\n.parking-status-container-col2 .status-count-container .label {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  font-weight: bold;\n  color: #8c8c8c;\n  line-height: 18px;\n}\n.parking-status-container-col2 .status-count-container .label-full-screen {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 16px;\n  font-weight: bold;\n  color: #8c8c8c;\n  line-height: 18px;\n}\n.parking-status-container-col2 .status-count-container .status-container {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 7px;\n}\n.parking-status-container-col2 .status-count-container .parked-status-bgcolor {\n  height: 10px;\n  width: 14px;\n  background-color: green;\n}\n.parking-status-container-col2 .status-count-container .empty-status-bgcolor {\n  height: 10px;\n  width: 14px;\n  background-color: #265caa;\n}\n.parking-status-container-col2 .status-count-container .dead-status-bgcolor {\n  height: 10px;\n  width: 14px;\n  background-color: #a9a9a9;\n}\n.parking-status-container-col2 .status-count-container .booked-status-bgcolor {\n  height: 10px;\n  width: 14px;\n  background-color: #f4cc07;\n}\n.parking-status-container-col2 .status-count-container .total-status-bgcolor {\n  height: 10px;\n  width: 14px;\n}\n.dashboard-footer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10px;\n  font-size: 12px;\n  font-weight: bold;\n}\n.red-color-text {\n  color: red;\n}\n.blue-color-text {\n  color: blue;\n}\n.parking-popover-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.parking-popover-title {\n  font-weight: bold;\n}\n.close-icon {\n  display: flex;\n  align-items: center;\n  font-size: 24px;\n  cursor: pointer;\n}\n.text-red {\n  color: red;\n  margin: 1rem 0px;\n}\n.details-container {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.details-container .detail-row {\n  display: flex;\n  justify-content: space-between;\n}\n.details-container .label {\n  width: 120px;\n  text-align: left;\n}\n.details-container .value {\n  font-weight: bold;\n  flex: 1;\n  text-align: left;\n}\n.space--width {\n  width: 100%;\n}\n.main-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 10vh;\n  min-width: 30vh;\n}\n.popover-loading {\n  position: absolute;\n  left: 44%;\n  top: 45%;\n}\n.card-wrapper {\n  position: relative;\n}\n.resync-icon {\n  font-size: 1.2rem;\n  color: var(--app-primary-color);\n  cursor: pointer;\n  background-color: #fff;\n  border-radius: 50%;\n  padding: 4px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  transition: transform 0.2s, box-shadow 0.2s;\n  margin-right: 0.5rem;\n  margin-top: -2px;\n}\n.resync-icon:hover {\n  transform: scale(1.1);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n}\n.maximize-icon {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 10;\n  font-size: 1.2rem;\n  color: var(--app-primary-color);\n  cursor: pointer;\n  background-color: #fff;\n  border-radius: 50%;\n  padding: 4px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n.maximize-icon:hover {\n  transform: scale(1.1);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n}\n.full-screen-layout {\n  height: 100%;\n  width: 100%;\n}\n@keyframes blink-execution {\n  0% {\n    background-color: white;\n  }\n  50% {\n    background-color: #ff7400;\n  }\n  100% {\n    background-color: white;\n  }\n}\n.blinking-record-execution {\n  animation: blink-execution 1s linear infinite;\n  color: #000000;\n}\n.parking-status-count-container {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 5px 15px;\n  border-top: 1px solid #f0f0f0;\n  background-color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.parking-status-execution {\n  background-color: #ff7400;\n  color: #ffffff;\n  font-weight: bold;\n}\n.parking-status-waiting {\n  background-color: #F4CC89;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard-container": `index-module__dashboard-container__tDY29`,
	"section1": `index-module__section1__XqiUd`,
	"section2": `index-module__section2__C8xX5`,
	"card-container": `index-module__card-container__heTI3`,
	"card-title": `index-module__card-title__Y8PgT`,
	"card-title-full-screen": `index-module__card-title-full-screen__nZeYh`,
	"parking-card-section": `index-module__parking-card-section__mpgPs`,
	"parking-card-section-full-screen": `index-module__parking-card-section-full-screen__FhB4B`,
	"search-component": `index-module__search-component__A7XxC`,
	"card-header": `index-module__card-header__uxrPC`,
	"card-header-full-screen": `index-module__card-header-full-screen__gm4F_`,
	"table-cell": `index-module__table-cell__RXuGJ`,
	"table-cell-small": `index-module__table-cell-small__RThEy`,
	"card-header-section": `index-module__card-header-section__scihd`,
	"custom-table-header": `index-module__custom-table-header__KsmZA`,
	"panel-header": `index-module__panel-header__ehX68`,
	"parking-card-header": `index-module__parking-card-header__jLjSC`,
	"visitor-icon-section": `index-module__visitor-icon-section__OXzem`,
	"visitor-table-section": `index-module__visitor-table-section___g6ZJ`,
	"parking-grid": `index-module__parking-grid__a01I6`,
	"parking-grid-full-screen": `index-module__parking-grid-full-screen__KyMF8`,
	"parking-cell": `index-module__parking-cell__ewjAR`,
	"ant-tag": `index-module__ant-tag__hoOo3`,
	"selected-cell": `index-module__selected-cell__gFHMB`,
	"parked-status-color": `index-module__parked-status-color__lCugE`,
	"empty-status-color": `index-module__empty-status-color__HX7j1`,
	"dead-status-color": `index-module__dead-status-color__ddZbI`,
	"booked-status-color": `index-module__booked-status-color__AUMvD`,
	"user-icon": `index-module__user-icon__cx0D5`,
	"card-count": `index-module__card-count__ZLsoH`,
	"visitor-section1": `index-module__visitor-section1__uZ3WR`,
	"visitor-section1-full-screen": `index-module__visitor-section1-full-screen__RGwNk`,
	"user-image": `index-module__user-image__GaFIj`,
	"parking-status-container-full-screen": `index-module__parking-status-container-full-screen__NddxU`,
	"parking-status-container": `index-module__parking-status-container__WpMx5`,
	"parking-status-container-col2": `index-module__parking-status-container-col2__k4RKf`,
	"border-status-box1": `index-module__border-status-box1__nnUfF`,
	"border-status-box2": `index-module__border-status-box2__VRITB`,
	"border-status-box3": `index-module__border-status-box3__OoMJ1`,
	"status-count-container": `index-module__status-count-container__NsXYn`,
	"count": `index-module__count__Rhlkt`,
	"count-full-screen": `index-module__count-full-screen__HYM6W`,
	"label": `index-module__label__jZ9LT`,
	"label-full-screen": `index-module__label-full-screen__dV05d`,
	"status-container": `index-module__status-container__iNiwz`,
	"parked-status-bgcolor": `index-module__parked-status-bgcolor__f823S`,
	"empty-status-bgcolor": `index-module__empty-status-bgcolor__Rgx9M`,
	"dead-status-bgcolor": `index-module__dead-status-bgcolor__lJbkI`,
	"booked-status-bgcolor": `index-module__booked-status-bgcolor__OIdVn`,
	"total-status-bgcolor": `index-module__total-status-bgcolor__FgxLV`,
	"dashboard-footer": `index-module__dashboard-footer__pEOQj`,
	"red-color-text": `index-module__red-color-text__X4eFI`,
	"blue-color-text": `index-module__blue-color-text__ZvmjQ`,
	"parking-popover-header": `index-module__parking-popover-header__aXFJJ`,
	"parking-popover-title": `index-module__parking-popover-title__H7g0r`,
	"close-icon": `index-module__close-icon__FoXPY`,
	"text-red": `index-module__text-red__M1Vk1`,
	"details-container": `index-module__details-container__FJWev`,
	"detail-row": `index-module__detail-row__aN2n7`,
	"value": `index-module__value__khiTw`,
	"space--width": `index-module__space--width__TBvHq`,
	"main-container": `index-module__main-container__lTyb7`,
	"popover-loading": `index-module__popover-loading__yUi_a`,
	"card-wrapper": `index-module__card-wrapper__VOaVc`,
	"resync-icon": `index-module__resync-icon__Kl496`,
	"maximize-icon": `index-module__maximize-icon__NPihT`,
	"full-screen-layout": `index-module__full-screen-layout__U37TE`,
	"blinking-record-execution": `index-module__blinking-record-execution__HNZXV`,
	"blink-execution": `index-module__blink-execution__zjWAe`,
	"parking-status-count-container": `index-module__parking-status-count-container__jyvEv`,
	"parking-status-execution": `index-module__parking-status-execution__jfD_8`,
	"parking-status-waiting": `index-module__parking-status-waiting__QVFlr`
};
export default ___CSS_LOADER_EXPORT___;
